import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getToken } from '../helpers/Token';
import ghMarketUrls from "../configs/gh_market/ghMarketUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const ghMarketApi: ApiInterface = axios.create({ baseURL: ghMarketUrls.baseURL })
ghMarketApi.interceptors.request.use(onRequest);

export default ghMarketApi;
